export const DEVICE_STORE = 'DEVICE_STORE';
export const DEVICE_UPDATE = 'DEVICE_UPDATE';
export const DEVICE_DESTROY = 'DEVICE_DESTROY';
